import { useState, useEffect } from 'react';

const GbitTableHeaderCol = ({
  tableName,
  keyVal,
  labelType,
  labelOption,
  dataType,
  dataOption,
  name,
  rowSpan,
  width,
  headerClicked,
  headerChange,
  initHeaderValue,
}) => {
  const [headerValue, setHeaderValue] = useState(null);
  const [optionList, setOptionList] = useState([]);

  useEffect(() => {
    if (labelType === 'check') {
      setHeaderValue(false);
    }
  }, []);

  const checkChangeEvt = e => {
    const param = { tableName: tableName, keyVal: keyVal, val: !headerValue };
    setHeaderValue(!headerValue);
    headerClicked(param);
  };

  const selectChange = e => {
    const param = { tableName: tableName, keyVal: keyVal };
    setHeaderValue(e.target.value);
    headerChange(param, e.target.value);
  };

  return (
    <>
      <th scope="col" aria-label={tableName + '_' + keyVal}>
        {labelType === 'check' ? (
          <div className="form-check">
            <input
              type="checkbox"
              id={tableName + '_' + keyVal}
              name="allSelected"
              checked={headerValue}
              onChange={checkChangeEvt}
              aria-labelledby={tableName + '_' + keyVal}
            />
            <label htmlFor={tableName + '_' + keyVal}>
              <span className="sr-only">전체선택</span>
            </label>
          </div>
        ) : labelType === 'select' ? (
          <div className="input__select">
            <select value={headerValue} onChange={selectChange}>
              <option>선택</option>
              {optionList.map(item => {
                return <option value={item.value}>{item.name}</option>;
              })}
            </select>
          </div>
        ) : labelType === 'badge' ? (
          labelOption === 'grey' ? (
            <span className="badge">{name}</span>
          ) : labelOption === 'blue' ? (
            <span className="badge badge--blue">{name}</span>
          ) : (
            <></>
          )
        ) : labelType === 'symbol' ? (
          <>{keyVal === 'arrow' ? <i className="fe-arrow-right"></i> : <></>}</>
        ) : (
          <>{name}</>
        )}
      </th>
    </>
  );
};

export default GbitTableHeaderCol;
